import { render, staticRenderFns } from "./RetakeStudentList.vue?vue&type=template&id=31d3a98b"
import script from "./RetakeStudentList.vue?vue&type=script&lang=js"
export * from "./RetakeStudentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports